import { ChiptaElement, html, css, unsafeCSS } from 'chipta-libs/main.js';


class IconBadge extends ChiptaElement {

  render() {
    return html`
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <circle cx="12" cy="8" r="7"></circle>
        <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>
      </svg>
    `;
  }

  static get styles() {
    return css`
      svg {
        width: 4em;
        height: 4em;
        stroke-width: 1;
        display: block;
        margin-right: 1em;
        color: ${unsafeCSS(_themeData.brand_primary_color)};
      }
    `;
  }
}


customElements.define('icon-badge', IconBadge);
